import { SSNField, FormStepFailure, FormStepSuccess, CreateAccountFailureComponent, CreateAccountSuccessComponent, MultiStepForm, FormStep, InputField, SelectField, PasswordField, CheckboxField, TelephoneField, CountryField, CurrencyField, UsernameField, DateField, AddressField, FieldReference, INDIA_STATES, SelectFieldOption, CANADA_PROVINCES_TERRITORIES } from '@whitehatgaming/shared';
import { CreateAccountComponent } from "./create-account/create-account.component";

// TODO: (Nice to have) - figure out a nice way to make this easier to make with default options, something like register ['firstname', 'lastName']
// TOOD: (Nice to have) - We need a way to check that all "required" stuff by platform is atleast given... (nice to have though... definitely later date)
export const register: MultiStepForm = new MultiStepForm({

  rootComponent: CreateAccountComponent,

  success: new FormStepSuccess({
    path: 'success',
    component: CreateAccountSuccessComponent
  }),

  failure: new FormStepFailure({
    path: 'failed',
    component: CreateAccountFailureComponent
  }),

  steps: [

    new FormStep({
      key: 'personal-details',
      title: "@personal-details-title",
      supportingText: '@personal-details-supporting-text',
      buttonText: '@personal-details-button-text',
      fields: [

        new InputField({
          key: 'firstname',
          label: '@first-name',
          value: '',
          required: true
        }),

        new InputField({
          key: 'lastname',
          label: '@last-name',
          value: '',
          required: true
        }),

        new SelectField({
          key: 'gender',
          label: '@gender',
          value: '',
          placeholder: '@gender-please-select',
          options: [
            { key: 'M', value: '@gender-male' },
            { key: 'F', value: '@gender-female' },
            { key: '', value: '@gender-other' }
          ]
        }),

        new DateField({
          key: 'dob',
          label: '@birth-date',
          preText: '@date-format',
          value: '',
          required: true
        }),

        new CountryField({
          key: 'country',
          label: '@country',
          required: true
        }),

        new SelectField({
          key: 'state',
          label: '@state',
          placeholder: '@please-select',
          required: true,
          conditional: 'this.country === "IN"',
          options: INDIA_STATES.map<SelectFieldOption>(state => ({
            key: state,
            value: state
          }))
        }),

        new SelectField({
          key: 'state',
          label: '@state-CA',
          placeholder: '@please-select',
          required: true,
          conditional: 'this.country === "CA"',
          options: CANADA_PROVINCES_TERRITORIES.map<SelectFieldOption>(state => ({
            key: state,
            value: state
          }))
        }),

        new SSNField({
          key: 'ssn',
          label: '@personal-identity-number',
          preText: '@personal-identity-number-help-text',
          value: ''
        })
      ]
    }),

    new FormStep({
      key: 'address-details',
      buttonText: '@address-details-continue',
      title: '@address-details-title',
      supportingText: '@address-details-supporting-text',
      fields: [

        new InputField({
          key: 'email',
          label: '@email',
          value: '',
          required: true,
          type: 'email',
          pattern: new RegExp(/(?!.*\.{2})^([a-zA-Z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-zA-Z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-zA-Z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-zA-Z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-zA-Z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/)

        }),

        new TelephoneField({
          key: 'phone',
          label: '@phone',
          required: true
        }),

        new AddressField({
          key: 'address',
          label: '@address',
          required: false
        })
      ]
    }),

    new FormStep({
      key: 'account-details',
      buttonText: '@sign-up',
      title: '@account-details-title',
      supportingText: '@account-details-supporting-text',
      fields: [

        new UsernameField({
          key: 'username',
          label: '@username',
          value: '',
          preText: '@username-help-text',
          required: true
        }),

        new PasswordField({
          key: 'password',
          label: '@password',
          preText: '@password-help-text',
          value: '',
          minLength: 8,
          required: true,
          email: new FieldReference('email')
        }),

        new CurrencyField({
          key: 'currency',
          label: '@currency',
          required: true,
          country: new FieldReference('country')
        }),

        new CheckboxField({
          key: 'termsPrivacyFunds',
          label: '@terms-and-conditions-privacy-policy-and-funds-policy',
          required: true
        })
      ]
    })

  ]
});
